
export enum Countries {
    NL = 'nl',
    UK = 'uk',
    FR = 'fr'
  }
  